import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col, message } from "antd";
import PropTypes from "prop-types";
import { GrantsTable, SearchResultText } from "../../styles";
import RemovePopup from "../../../../../../CommonComponents/CharitySearch/Component/RemovePopup/RemovePopup";
import RemoveGeminiPopup from "../../../../../../CommonComponents/CharitySearch/Component/RemoveGemini/RemoveGeminiPopup";
import { tableConfig } from "../../../../../../CommonComponents/CharitySearch/config";
import { geminiTableConfig } from "../../../../../../CommonComponents/CharitySearch/geminiConfig";
import MultipleCharityPopup from "../../../../../../CommonComponents/CharitySearch/Component/MultipleCharity/MultipleCharity";
import RenderCard from "../../../RecommendGrant/Component/RenderCard/RenderCard";
import { LoadMoreButton, EndResult, BtnWrapper } from "./style";
import {
  updateFromCounter,
  agreementUpdateLoadMoreCounter,
  agreementUpdatefrom,
  agreementGeminiEinData,
  agreementEinData,
  cancelSaveCharity,
  agreementPostSavedCharity,
} from "../../actions";
import { getPrimaryAccount } from "../../../../../../utils/sessionUtil";
import { charityEligibilityChecker } from "../../../../../../utils/commonUtil";
import { handleGuideStarRedirect } from "../../../../../../CommonComponents/CharitySearch/utils";
import DrupalPopup from "../../../RecommendGrant/Component/Popup/DrupalPopup";
import { GeneralButton } from "../../../../../../CommonComponents/Commons/commonComponents";
import { searchTableDerivedStates } from '../../Selectors/SearchTableSelectors';
export class SearchTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: 2,
      error: false,
      counter: 1,
      visiblePopup: false,
      visibleGeminiPopup: false,
      showSavedCharityData: "",
      savedGeminiData: "",
      fetchGeminiEinSuccessData: "",
      ein: "",
      legalName: "",
      addressLine1: "",
      addressLine2: "",
      addressLine3: "",
      state: "",
      city: "",
      country: "",
      zip: "",
      charityContactFirstName: "",
      charityContactLastName: "",
      email: "",
      phoneNumber: "",
      selectedCharity: {},
      multipleCharities: [],
      partialEligibility: false,
      eligible: true,
      selectedCharityData: {},
    };
    this.multipleCharitySaveHandler = this.multipleCharitySaveHandler.bind(
      this
    );
  }

  savedCharityModal = (data) => {
    this.setState({
      visiblePopup: !this.state.visiblePopup,
      showSavedCharityData: data,
      showPopup: !this.state.showPopup,
    });
  };

  savedGeminiModal = (data) => {
    this.setState({
      visibleGeminiPopup: !this.state.visibleGeminiPopup,
      savedGeminiData: data,
    });
  };

  handleMapping = (data) => {
    const cloneState = { ...data };
    const keyArr = Object.keys(cloneState);
    let newObj = {};
    keyArr.forEach((item, i) => {
      if (data[item]) {
        newObj[item] = data[item];
      } else {
        if (data[item] !== undefined) newObj[item] = "";
      }
    });
    return newObj;
  };

  removeSavedCharityModal = (data) => {
    const obj = this.handleMapping(data);
    this.setState({ selectedCharityData: obj });
    const eligibility = charityEligibilityChecker({
      pub78: obj.properties.pub78_verified,
      bmfStatus: obj.properties.bmf_status,
      subSection: obj.subsection_code,
      foundationCode: obj.foundation_code,
    });
    if (eligibility.mandatory && eligibility.partial) {
      this.props.saveCharity(obj, this.multipleCharitySaveHandler);
    } else if (eligibility.mandatory && !eligibility.partial) {
      this.setState({ partialEligibility: true });
    } else {
      this.setState({ eligible: false });
    }
  };

  saveInEligibleCharities = () => {
    const { selectedCharityData } = this.state;
    this.setState({ partialEligibility: false, eligible: true });
    let recordToSave = {
      ein: selectedCharityData.ein,
      legalName: selectedCharityData.organization_name,
      addressLine1: selectedCharityData.address_line_1,
      addressLine2: selectedCharityData.address_line_2,
      addressLine3: "",
      state: selectedCharityData.state,
      city: selectedCharityData.city,
      country: "US",
      zip: selectedCharityData.zip,
      charityContactFirstName: selectedCharityData.contact_name,
      charityContactLastName: "",
      email: selectedCharityData.contact_email,
      phoneNumber: selectedCharityData.contact_phone,
    };
    this.props.saveAgreementCharity(
      {
        userId: getPrimaryAccount().userId,
        charityData: recordToSave,
      },
      (response) =>
        this.multipleCharitySaveHandler(response, selectedCharityData)
    );
  };

  multipleCharitySaveHandler = (savedRecord, reqRecord) => {
    if (savedRecord.isExisting) {
      if (savedRecord.granteeOrgs && savedRecord.granteeOrgs.length === 1) {
        // add charity directly and proceed
        this.saveSelectedCharity(savedRecord.granteeOrgs[0]);
      } else if (
        savedRecord.granteeOrgs &&
        savedRecord.granteeOrgs.length > 1
      ) {
        // show multiple charity popup
        // if user tries to save multiple with ein conflict, keep first cancel rest
        if (!Object.keys(this.state.selectedCharity).length) {
          this.setState({
            multipleCharities: savedRecord.granteeOrgs,
            selectedCharity: { ...reqRecord },
          });
        } else {
          this.props.cancelSaveCharity(reqRecord);
        }
      }
    }
  };

  saveSelectedCharity = (charity) => {
    this.props.addCharity(charity);
    this.setState({
      multipleCharities: [],
      selectedCharity: {},
    });
  };

  onCancelMultipleCharity = () => {
    this.props.cancelSaveCharity(this.state.selectedCharity);
    this.setState({
      multipleCharities: [],
      selectedCharity: {},
    });
  };

  removedGeminiModal = (data) => {
    this.props.saveGeminiCharity(data);
    this.setState({
      fetchGeminiEinSuccessData: data.ein,
    });
  };

  updateFromCounter = (data) => {
    this.setState(
      (prev) => {
        return { visible: prev.visible + data };
      },
      () => {
        this.props.agreementUpdateLoadMoreCounter(data);
      }
    );
  };

  savedCharityHandler = () => {
    message.success("Your charity is saved");
    this.props.getSavedCharity(getPrimaryAccount().userId);
  };

  componentWillReceiveProps(nextprops) {
    if (
      nextprops.charitySaved &&
      nextprops.charitySaved !== this.props.charitySaved
    ) {
      this.savedCharityHandler();
    }

    if (
      this.props.updatedSearchData.length !== nextprops.updatedSearchData.length
    ) {
      let counter = nextprops.updatedCounterData;
      this.setState({ counter: counter });
    }
  }

  render() {
    const {
      columnData,
      updatedSearchData,
      pendingCharityHandler,
      updatedCounterData,
      showGeminiFilter,
      activityBlocked = "",
    } = this.props;
    const {
      counter,
      showSavedCharityData,
      visiblePopup,
      visibleGeminiPopup,
      savedGeminiData,
      multipleCharities,
    } = this.state;
    const {
      savedCharityModal,
      removeSavedCharityModal,
      removedGeminiModal,
      savedGeminiModal,
    } = this;
    return (
      <div>
        <Row>
          {showGeminiFilter ? (
            <>
              <Row>
                {/* <SearchResultText>Search Results</SearchResultText> */}
                {/* <TableLabel>Displaying {columnData.length} Results</TableLabel> */}
              </Row>
              <Col lg={24} md={24} xs={0}>
                <GrantsTable
                  className="main"
                  columns={geminiTableConfig(
                    pendingCharityHandler,
                    savedGeminiModal,
                    removedGeminiModal,
                    activityBlocked
                  )}
                  dataSource={columnData}
                  pagination={false}
                />
                <EndResult>
                  You have reached the end of search results.
                </EndResult>
                {/* {this.state.visible < columnData.length && (
              <p onClick={() => this.props.agreementUpdatefrom()}> Load more</p>
            )} */}
              </Col>
              <Col lg={0} md={0} xs={24}>
                {columnData.map((data, index) => (
                  <div key={data.legalName}>
                    <RenderCard
                      index={index}
                      data={data}
                      component="SearchGeminiCard"
                      pendingCharityHandler={pendingCharityHandler}
                      removedGeminiModal={removedGeminiModal}
                      savedGeminiModal={savedGeminiModal}
                      activityBlocked={activityBlocked}
                    />
                  </div>
                ))}
                <EndResult>
                  You have reached the end of search results.
                </EndResult>
              </Col>
            </>
          ) : (
            <>
              <Row>
                {/* <SearchResultText>Search Results</SearchResultText>
               <TableLabel>Displaying {updatedSearchData.length} Results</TableLabel> */}
              </Row>
              <Col lg={24} md={24} xs={0}>
                <GrantsTable
                  className="main"
                  columns={tableConfig(
                    pendingCharityHandler,
                    savedCharityModal,
                    removeSavedCharityModal,
                    activityBlocked,
                    handleGuideStarRedirect
                  )}
                  dataSource={updatedSearchData}
                  pagination={false}
                />

                {this.props.guidestarSearchCount === columnData.length ? (
                  <div></div>
                ) : (
                  <BtnWrapper>
                    <GeneralButton
                      type="functional"
                      width="300px"
                      onClick={() => this.props.agreementUpdatefrom()}
                      id="btnLoadMore"
                      text="Load more"
                    >
                    </GeneralButton>
                  </BtnWrapper>
                )}
              </Col>
              <Col lg={0} md={0} xs={24}>
                {updatedSearchData.map((data, index) => (
                  <div key={data.ein}>
                    <RenderCard
                      index={index}
                      data={data}
                      component="SearchCharityCard"
                      pendingCharityHandler={pendingCharityHandler}
                      removeSavedCharityModal={removeSavedCharityModal}
                      savedCharityModal={savedCharityModal}
                      activityBlocked={activityBlocked}
                      searchResultClickHandler={handleGuideStarRedirect}
                    />
                  </div>
                ))}
                {this.props.guidestarSearchCount === columnData.length ? (
                  <div></div>
                ) : (
                  <BtnWrapper>
                    <GeneralButton
                      type="functional"
                      width="100%"
                      onClick={() => this.props.agreementUpdatefrom()}
                      id="btnLoadMoreAgrmtUpdate"
                      text="Load more"
                    >
                    </GeneralButton>
                  </BtnWrapper>
                )}
              </Col>
            </>
          )}
        </Row>
        {visiblePopup ? (
          <RemovePopup
            page={"Grant Agreement"}
            showSavedCharityData={showSavedCharityData}
            removeCharity={this.props.removeSavedCharity}
            einData={this.props.einData}
            keyProperty={"Remove Charity Grant Agreements"}
          />
        ) : (
          <div />
        )}

        {visibleGeminiPopup ? (
          <RemoveGeminiPopup
            page={"Grant Agreement"}
            savedGeminiData={savedGeminiData}
            removeCharity={this.props.removeSavedCharity}
            geminiEinData={this.props.geminiEinData}
            keyProperty={"Remove Charity Grant Agreements"}
          />
        ) : (
          <div />
        )}

        {multipleCharities.length ? (
          <MultipleCharityPopup
            show={!!multipleCharities.length}
            charities={multipleCharities}
            secondaryCta={this.onCancelMultipleCharity}
            primaryCta={this.saveSelectedCharity}
          />
        ) : (
          ""
        )}
        <DrupalPopup
          html={true}
          page={"Grant Agreement"}
          show={!this.state.eligible}
          defaultPrimaryLabel={"Ok"}
          defaultSecondaryLabel={"Cancel"}
          defaultTitle={"Warning"}
          keyProperty={"Ineligible"}
          defaultDescription={"you are ineligible"}
          primaryCta={this.saveInEligibleCharities}
          secondaryCta={() => this.setState({ eligible: true })}
          alertId="ineligible"
        />
        <DrupalPopup
          html={true}
          page={"Grant Agreement"}
          show={this.state.partialEligibility}
          defaultPrimaryLabel={"Ok"}
          defaultSecondaryLabel={"Cancel"}
          defaultTitle={"Warning"}
          keyProperty={"Partial Eligible"}
          defaultDescription={"you are ineligible2"}
          primaryCta={this.saveInEligibleCharities}
          secondaryCta={() => this.setState({ partialEligibility: false })}
          alertId="partial-eligible"
        />
      </div>
    );
  }
}

SearchTable.propTypes = {
  addCharity: PropTypes.func,
  agreementUpdateLoadMoreCounter: PropTypes.func,
  agreementUpdatefrom: PropTypes.func,
  cancelSaveCharity: PropTypes.func,
  charitySaved: PropTypes.bool,
  columnData: PropTypes.array,
  einData: PropTypes.func,
  geminiEinData: PropTypes.func,
  getSavedCharity: PropTypes.func,
  guidestarSearchCount: PropTypes.number,
  pendingCharityHandler: PropTypes.func,
  removeSavedCharity: PropTypes.func,
  saveAgreementCharity: PropTypes.func,
  saveGeminiCharity: PropTypes.func,
  showGeminiFilter: PropTypes.bool,
  updatedCounterData: PropTypes.any,
  updatedSearchData: PropTypes.array,
  saveCharity: PropTypes.func
};

const mapStateToProps = (state) => ({
  ...searchTableDerivedStates(state.toJS()),
});

const mapDispatchToProps = (dispatch) => ({
  agreementUpdatefrom: () => dispatch(agreementUpdatefrom()),
  agreementUpdateLoadMoreCounter: (data) =>
    dispatch(agreementUpdateLoadMoreCounter(data)),
  geminiEinData: (data) => dispatch(agreementGeminiEinData(data)),
  einData: (data) => dispatch(agreementEinData(data)),
  cancelSaveCharity: (data) => dispatch(cancelSaveCharity(data)),
  saveAgreementCharity: (data, successFn) =>
    dispatch(agreementPostSavedCharity(data, successFn)),
});

export default connect(mapStateToProps, mapDispatchToProps, null, {
  pure: true,
})(SearchTable);
